import { GetLiveScheduleQuery } from "@src/@types/api.d";
import React from "react";
import { twMerge } from "tailwind-merge";
import Icon from "../Icon";
import moment from "moment";
import Link from "next/link";
import { getCookie } from "cookies-next";
import useStore from "@src/store";

interface ILiveSchedules {
  schedules: GetLiveScheduleQuery;
}

const LiveSchedules = ({ schedules }: ILiveSchedules) => {
  const isPreviewMode = useStore((state) => state.isPreviewMode);

  const [refreshToken, setRefreshToken] = React.useState<string>("");

  React.useEffect(() => {
    setRefreshToken(getCookie("evd") as string);
  }, []);

  return (
    <div className="w-full sm:h-[512px] sm:w-[512px] rounded-lg bg-white p-6 shadow-xl sm:p-8 overflow-auto">
      {isPreviewMode && (
        <p className="text-sm text-center text-[#71717A] mb-4">
          You are in preview mode.
        </p>
      )}
      <div className="flex w-full flex-col items-center gap-6">
        {schedules?.getLiveSchedule?.data?.map((i, idx) => (
          <div
            key={idx}
            className={twMerge(
              "w-full flex flex-col items-center gap-4 rounded-md bg-gray-50 p-4 hover:bg-gray-100 transition-colors"
            )}
          >
            <div className="flex flex-col items-center gap-2">
              <Icon iconName="roses" />
              <h3 className="text-xl font-semibold text-gray-800">
                {i?.event_part?.name}
              </h3>
            </div>
            <span className="text-sm font-light text-gray-600">
              {moment(i?.time).format("MMMM Do YYYY")}
            </span>
            <span className="text-sm font-light text-gray-600">
              {moment(i?.time).format("h:mm a")}
            </span>
            <Link
              passHref
              href={`${process.env.NEXT_PUBLIC_INAWO_STREAM_BASE_URL}?action=youtube&key=${i?.event_uuid}&schedule=${i?.id}&token=${refreshToken}`}
            >
              <a target="_blank">
                <button className="bg-white rounded h-[2.75rem] px-[1.5rem] flex items-center gap-[0.5rem] !border border-[#ffb800] mb-[0.75rem] hover:opacity-90 hover:ring-2 hover:ring-offset-1 hover:ring-[#ffb800] ease-in-out duration-300 transition">
                  <Icon iconName="videoCamera" />
                  <span className="">Watch Live</span>
                </button>
              </a>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LiveSchedules;
